export const DEFAULT_REDIRECT = "/dashboard";

export const getRedirectForm = (search: string) => {
  const params = new URLSearchParams(search);
  const raw = params.get("redirect");

  if (!raw) return DEFAULT_REDIRECT;

  try {
    return decodeURIComponent(decodeURIComponent(raw));
  } catch {
    return decodeURIComponent(raw);
  }
};
